module.exports = __webpack_public_path__ + "asset/image-ic_category_34-6ccb1d0f4b06f473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_34.svg
// module id = HOha
// module chunks = 0